<template>
  <transition name="ae-fade">
    <div
      class="non-selection block superPosition"
      :class="superPosition"
      v-show="showSuper"
      v-bind:style="superPositionStyle"
    >
      <div class="block">
        <input
          name="text1"
          data-frame-action="SUPER"
          type="text"
          ref="textInputOne"
          placeholder="Insert Super text here"
          v-model="tmpAGD.superName"
          :disabled="!primary"
        />
        <input
          name="text2"
          data-frame-action="SUPER"
          type="text"
          ref="textInputTwo"
          placeholder="Optional Second Line"
          v-model="tmpAGD.superTitle"
          :disabled="!primary"
        />
      </div>
      <div
        class="block positionToolbar clearfix"
        data-toggle="buttons-checkbox"
      >
        <a
          href="#"
          :class="{
            active: superPosition == 'LOWER_LEFT',
            disabled: creditPosition == 'LOWER_LEFT',
          }"
          v-on:click="changeSuperPosition('LOWER_LEFT')"
        >
          <i class="wticon wticon-super-bottom-left" />
        </a>
        <a
          href="#"
          :class="{
            active: superPosition == 'LOWER_RIGHT',
            disabled: creditPosition == 'LOWER_RIGHT',
          }"
          v-on:click="changeSuperPosition('LOWER_RIGHT')"
        >
          <i class="wticon wticon-super-bottom-right" />
        </a>
        <a
          href="#"
          :class="{
            active: superPosition == 'UPPER_LEFT',
            disabled: creditPosition == 'UPPER_LEFT',
          }"
          v-on:click="changeSuperPosition('UPPER_LEFT')"
        >
          <i class="wticon wticon-super-top-left" />
        </a>
        <a
          href="#"
          :class="{
            active: superPosition == 'UPPER_RIGHT',
            disabled: creditPosition == 'UPPER_RIGHT',
          }"
          v-on:click="changeSuperPosition('UPPER_RIGHT')"
        >
          <i class="wticon wticon-super-top-right" />
        </a>
      </div>
    </div>
  </transition>
</template>

<script>
/** (GW)
 * Asset Editor's supers stage Vue (stage bar)
 */

import bus from 'v/AssetEditor/AssetEditorEventBus';
import { mapActions, mapMutations, mapState } from 'vuex';

export default {
  props: {
    active: { type: Boolean, default: false },
    primary: { type: Boolean, default: false },
  },

  beforeDestroy: function () {
    bus.$off('apply', this.apply);
  },

  computed: {
    ...mapState('assetEditor', ['tmpAGD', 'stageDimensions']),

    showSuper: function () {
      return this.tmpAGD._showSuper;
    },

    superPosition: function () {
      // default position, prevent collision with credit position
      if (!_.isEmpty(this.tmpAGD.superPosition)) {
        return this.tmpAGD.superPosition;
      } else {
        if (this.creditPosition === 'LOWER_LEFT') {
          return 'UPPER_RIGHT';
        } else {
          return 'LOWER_LEFT';
        }
      }
    },

    superPositionStyle: function () {
      const direction = /_LEFT/.test(this.superPosition) ? 'left' : 'right';
      const style = {
        maxWidth: this.stageDimensions.visibleAreaWidth * 0.9 + 'px',
      };
      style[direction] =
        this.stageDimensions.curtainWidth +
        this.stageDimensions.curtainBorder +
        (direction === 'left' ? 1 : 0) +
        'px';
      return style;
    },

    creditPosition: function () {
      return this.tmpAGD.creditPosition;
    },
  },

  watch: {
    showSuper: function () {
      if (this.showSuper && this.primary) {
        this.focusInput();
      }
    },
  },

  mounted: function () {
    bus.$on('apply', this.apply);

    this.setTMPAGD({
      _showSuper: this.primary ? true : !_.isEmpty(this.tmpAGD.superName),
    });

    this.track({ e: 'selectedSuper' });
  },

  methods: {
    ...mapActions('assetEditor', ['changeCurrentPage', 'removePage', 'track']),
    ...mapMutations('assetEditor', ['setTMPAGD', 'setAGD']),

    focusInput: function () {
      this.$nextTick(function () {
        this.$refs.textInputOne.focus();
      });
    },

    changeSuperPosition: function (superPosition) {
      this.setTMPAGD({ superPosition });
      this.focusInput();
    },

    apply: function () {
      if (!this.active) {
        return;
      }
      if (
        !this.showSuper ||
        (!this.tmpAGD.superName && !this.tmpAGD.superTitle)
      ) {
        this.removePage('super');
      } else {
        this.setAGD({
          superPosition: this.superPosition,
          superName: this.tmpAGD.superName,
          superTitle: this.tmpAGD.superTitle,
        });
      }
      this.changeCurrentPage('preview');
    },
  },
};
</script>
